<template>
  <div>
    <div class="row align-items-end mb-3">
      <div class="col-md-4 col-sm-6">
        <label class="form-label font-weight-bold">Tipo de Alergia</label>
        <select v-model="selectedTipo" class="form-control form-control-sm">
          <option value="">-- Seleccione --</option>
          <option value="01">Medicamento</option>
          <option value="02">Alimento</option>
          <option value="03">Ambiental</option>
          <option value="04">Sustancia que entran en contacto con la piel</option>
          <option value="05">Picadura de insectos</option>
          <option value="06">Otra</option>
        </select>
      </div>
      <div class="col-md-3 col-sm-6">
        <label class="form-label font-weight-bold">Alergia (Concepto)</label>
        <input type="text" v-model="selectedConcepto" class="form-control form-control-sm" placeholder="Ej. Penicilina" />
      </div>
      <div class="col-md-3 col-sm-6">
        <label class="form-label font-weight-bold">Reacción</label>
        <input type="text" v-model="selectedReaccion" class="form-control form-control-sm" placeholder="Ej. Urticaria" />
      </div>
      <div class="col-md-2 col-sm-12">
        <button type="button" class="btn btn-primary btn-sm btn-block" @click="addAllergy">
          <i class="fa fa-plus fa-fw"></i> Agregar
        </button>
      </div>
    </div>

    <div v-if="value.length > 0" class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead class="bg-light">
          <tr>
            <th>Tipo</th>
            <th>Alergia</th>
            <th>Reacción</th>
            <th class="text-center" style="width: 50px;">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in value" :key="index">
            <td><span class="badge badge-info">{{ tipoLabel(item.tipo) }}</span></td>
            <td>{{ item.concepto }}</td>
            <td>{{ item.reaccion || 'N/A' }}</td>
            <td class="text-center">
              <button type="button" class="btn btn-danger btn-xs" @click="removeAllergy(index)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
const TIPOS = {
  '01': 'Medicamento',
  '02': 'Alimento',
  '03': 'Ambiental',
  '04':'Sustancias que entran en contacto con la piel',
  '05':'Picadura de insectos',
  '06': 'Otra',
};

export default {
  name: 'AllergyDetail',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedTipo: '',
      selectedConcepto: '',
      selectedReaccion: ''
    };
  },
  methods: {
    tipoLabel(code) {
      return TIPOS[code] || code || 'N/A';
    },
    addAllergy() {
      if (!this.selectedConcepto || !this.selectedTipo) return;

      const newDetail = {
        tipo_detalle: 'ALLERGY',
        tipo: this.selectedTipo,
        concepto: this.selectedConcepto,
        reaccion: this.selectedReaccion
      };

      this.$emit('input', [...this.value, newDetail]);

      this.selectedTipo = '';
      this.selectedConcepto = '';
      this.selectedReaccion = '';
    },
    removeAllergy(index) {
      const updated = [...this.value];
      updated.splice(index, 1);
      this.$emit('input', updated);
    }
  }
};
</script>

